import React from "react";
import { Routes, Route } from "react-router-dom";

import Home from "../pages/Home";
import Estimator from "../pages/Estimator";
import AboutUs from "../pages/About";
import Legal from "../pages/Legal";
import Account from "../pages/Account";
import NotFound from "../pages/NotFound";
import HowItWorks from "../pages/HowItWorks";
import Portfolio from "../pages/Portfolio";

const Main = () => {
  // const authenticate = (element) => {
  //   return <Authenticator>{element}</Authenticator>;
  // };

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/estimator" element={<Estimator />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/faq" element={<Legal />} />
      <Route path="/account" element={<Account />} />
      <Route path="/howitworks" element={<HowItWorks />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Main;
